import { render, staticRenderFns } from "./ServicePrivacy.vue?vue&type=template&id=2536a15d&"
import script from "./ServicePrivacy.vue?vue&type=script&lang=js&"
export * from "./ServicePrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports